import { DonationFundPaymentMethodEnum } from '@graphql/generated-base';

export const PLATFORM_LABELS: { [key in DonationFundPaymentMethodEnum]: string } = {
  [DonationFundPaymentMethodEnum.venmo]: 'Venmo',
  [DonationFundPaymentMethodEnum.paypal]: 'PayPal',
  [DonationFundPaymentMethodEnum.cashapp]: 'Cash App',
  [DonationFundPaymentMethodEnum.cashOrCheck]: '',
  [DonationFundPaymentMethodEnum.joyCredit]: '',
  [DonationFundPaymentMethodEnum.other]: '',
};

export enum PAYMENT_OPTIONS {
  CASH_OR_CHECK = 'cashOrCheck',
  CASH_APP = 'cashapp',
  VENMO = 'venmo',
  PAYPAL = 'paypal',
}

export const ExtraPaymentMethodOptions = {
  cashOrCheck: { name: 'CashOrCheck', value: 'cashOrCheck', label: 'Cash / Check' },
  cashapp: { name: 'Cashapp', value: 'cashapp', label: 'Cash App' },
  venmo: { name: 'Venmo', value: 'venmo', label: 'Venmo' },
  paypal: { name: 'Paypal', value: 'paypal', label: 'PayPal' },
};
